import { Component, ReactNode } from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';

/* Theme variables */
import '@acri-tools/react-tools/css/all.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './theme/app.css';

/** =========================================
 *  -- COMPONENTS
    ========================================= */

import { AdminOnly, RequiresLogin, RequiresLogout } from '@acri-tools/react-tools/utils/routing';
import { isMobile } from 'react-device-detect';

// Redux
import { connect } from 'react-redux';

import Menu from '@acri-tools/react-tools/components/Menu/Menu';
import { logo } from './theme/images';
import routes from './utils/routes';

import { on_app_did_update, on_app_mount, on_app_unmount } from '@acri-tools/react-tools';
import Toasts from '@acri-tools/react-tools/components/Toasts/Toasts';
import { createBrowserHistory } from 'history';
/** =========================================
 *  -- PAGES
 ========================================= */
import Admin from '@acri-tools/react-tools/pages/Admin/Admin';
import { IntlProvider } from 'react-intl';
import Footer from './components/Footer/Footer';
import AboutUs from './pages/AboutUs/AboutUs';
import Account from './pages/Account/Account';
import { admin_routes } from './pages/Admin/Admin';
import ArchiveContent from './pages/ArchiveContent/ArchiveContent';
import Contacts from './pages/Contacts/Contacts';
import DIS from './pages/DIS/DIS';
import DataMaintenance from './pages/DataMaintenance/DataMaintenance';
import Deliveries from './pages/Deliveries/Deliveries';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import HistoricalData from './pages/HistoricalData/HistoricalData';
import Home from './pages/Home/Home';
import KPI from './pages/KPI/KPI';
import LiveMissions from './pages/LiveMissions/LiveMissions';
import LoadingPage from './pages/LoadingPage/LoadingPage';
import Login from './pages/Login/Login';
import MediaStatus from './pages/MediaStatus/MediaStatus';
import Minutes from './pages/Minutes/Minutes';
import News from './pages/News/News';
import NewsPage from './pages/NewsPage/NewsPage';
import OnlineMissions from './pages/OnlineMissions/OnlineMissions';
import Project from './pages/Project/Project';
import Projects from './pages/Projects/Projects';
import Reports from './pages/Reports/Reports';
import RetrievalForms from './pages/RetrievalForms/RetrievalForms';
import RetrievalStatus from './pages/RetrievalStatus/RetrievalStatus';
import Services from './pages/Services/Services';
import Throughput from './pages/Throughput/Throughput';
import UpdateEmail from './pages/UpdateEmail/UpdateEmail';
import UpdatePassword from './pages/UpdatePassword/UpdatePassword';
import VerifyRegistration from './pages/VerifyRegistration/VerifyRegistration';
import { fetch_global_data } from './utils/data';
// testing rebuild

import languages from '@acri-tools/react-tools/languages';
import { RTAppState } from '@acri-tools/react-tools/redux/reducers/RTAppReducer';
import { GDPRState } from '@acri-tools/react-tools/redux/reducers/gdprReducer';
import { LanguagesState } from '@acri-tools/react-tools/redux/reducers/languagesReducer';
import { LoginState } from '@acri-tools/react-tools/redux/reducers/loginReducer';
import { RoutingState } from '@acri-tools/react-tools/redux/reducers/routingReducer';
import { Route as AppRoute } from "@acri-tools/react-tools/utils/menu";
import TopBarLogin from './components/TopBarLogin/TopBarLogin';
import DampsDatabase from './pages/DampsDatabase/DampsDatabase';
import Ftp from './pages/Ftp/Ftp';
import GDPR from './pages/GDPR/GDPR';


interface Props {
    // ======== REDUX =========
    login: LoginState
    rt_app: RTAppState
    routing: RoutingState
    gdpr: GDPRState

    languages: LanguagesState
}
const history = createBrowserHistory();

class App extends Component<Props, {}> {
    defaultLoggedinRedirect = () => {
        return (
            isMobile ?
                <Redirect to="/" />
                :
                <Redirect to="/" />
        )
    }
    componentDidMount() {
        on_app_mount(history, {
            rt_app: {
                modules: {
                    article_manager: true,
                    file_manager: true,
                },
                GAHosts: {
                    'dev.damps.acri-st.fr': 'G-HPZXKWNNX1',
                    'damps.info': 'G-2CBS3EVQFW',
                    'www.damps.info': 'G-2CBS3EVQFW'
                },
            },
            layout: {
                // signed_in_message: "Logged in",
                logo: logo,
                footer: <Footer />,
                mobileWidth: 1500,
                gdpr: <GDPR />,
                // navbar: <NavBar/>
                top_bar_authentication: <TopBarLogin />,
                reducedWidth: 1800
            },
            routing: {
                routes
            },
            article_manager: {
                options: {
                    categories: [
                        'General', 'DAMPS Archive', 'DIS'
                    ]
                },
            },
            languagesInit: {
                default: 'en',
                languages: {
                    en: languages.en
                }
            }
        });

        fetch_global_data();
    }
    componentWillUnmount() {
        on_app_unmount();
    }

    componentDidUpdate(prevProps: Props) {
        on_app_did_update(prevProps, this.props)
    }

    get_route_anchor = (route: AppRoute): ReactNode => (
        <>
            {
                route.route &&
                <a href={route.route} rel="canonical"> {route.name} </a>
            }
            {
                route.subMenu &&
                route.subMenu.map((r) => this.get_route_anchor(r))
            }
        </>
    )

    render() {

        // console.log('history',this.props.history);
        return (
            <IntlProvider locale={this.props.languages.language || 'en'} messages={this.props.languages.languages?.[this.props.languages.language || 'en']}>
                <div id="app" className={isMobile ? 'mobile' : undefined}>
                    {
                        // (this.props.routing.routes || this.props.routing.routes?.() )?.map((route:any)=>(
                        //     this.get_route_anchor(route)
                        // ))
                    }

                    {
                        !this.props.rt_app.initialized ?
                            <LoadingPage />
                            :
                            <Router history={history}>
                                <Menu />
                                <Toasts />
                                <Switch>
                                    <Route path="/admin/:selected?/:subSelected?" exact render={(props) =>
                                        <RequiresLogin>
                                            <AdminOnly>
                                                <Admin
                                                    routes={routes}
                                                    logo={logo}
                                                    article_manager
                                                    file_manager
                                                    custom_menu={admin_routes}
                                                    {...props}
                                                />
                                            </AdminOnly>
                                        </RequiresLogin>
                                    } />

                                    {/* CONTENT */}

                                    <Route path="/" exact render={() =>
                                        <Home />
                                    } />
                                    <Route path="/services" exact render={() =>
                                        <Services />
                                    } />
                                    <Route path="/archive-content" exact render={() =>
                                        <ArchiveContent />
                                    } />
                                    <Route path="/retrieval-status" exact render={() =>
                                        <RetrievalStatus />
                                    } />

                                    {/* DIS */}
                                    <Route path="/DIS" exact render={() =>
                                        <DIS />
                                    } />
                                    {/* <Route path="/DIS/monthly-executive-summary" exact render={() =>
                                            <DISSummary/>
                                        }/> */}

                                    <Route path="/about-us" exact render={() =>
                                        <AboutUs />
                                    } />

                                    {/* INGESTION MONITORING */}
                                    <Route path="/ingestion-monitoring/historical-data" exact render={() =>
                                        <HistoricalData />
                                    } />
                                    <Route path="/ingestion-monitoring/live-missions" exact render={() =>
                                        <LiveMissions />
                                    } />
                                    <Route path="/ingestion-monitoring/online-missions" exact render={() =>
                                        <OnlineMissions />
                                    } />
                                    <Route path="/ingestion-monitoring/throughput-lm-om" exact render={() =>
                                        <Throughput />
                                    } />

                                    <Route path="/data-maintenance" exact render={() =>
                                        <DataMaintenance />
                                    } />




                                    {/* NEWS */}
                                    <Route path="/news" exact render={(props) =>
                                        <News {...props} />
                                    } />
                                    <Route path="/news/:id" exact render={(props) =>
                                        <NewsPage {...props} />
                                    } />


                                    {/* PROJECTS */}
                                    <Route path="/projects" exact render={(props) =>
                                        <Projects />
                                    } />
                                    <Route path="/project/:name" exact render={(props) =>
                                        <Project {...props} />
                                    } />
                                    <Route path="/ftp" exact render={(props) =>
                                        <Ftp />
                                    } />

                                    <Route path="/login" exact render={() =>
                                        <RequiresLogout>
                                            <Login />
                                        </RequiresLogout>
                                    } />
                                    <Route path="/account" exact render={(props) =>
                                        <RequiresLogin>
                                            <Account />
                                        </RequiresLogin>
                                    } />

                                    <Route path="/verify-registration/:token" exact render={(props) =>
                                        <RequiresLogout>
                                            <VerifyRegistration {...props} />
                                        </RequiresLogout>
                                    } />
                                    <Route path="/forgot-password" exact render={(props) =>
                                        <RequiresLogout>
                                            <ForgotPassword {...props} />
                                        </RequiresLogout>
                                    } />
                                    <Route path="/update-password/:token" exact render={(props) =>
                                        <UpdatePassword {...props} />
                                    } />
                                    <Route path="/update-email/:token" exact render={(props) =>
                                        <UpdateEmail {...props} />
                                    } />

                                    {/* INTERNAL */}
                                    <Route path="/internal/contacts" exact render={(props) =>
                                        <RequiresLogin>
                                            <Contacts />
                                        </RequiresLogin>
                                    } />
                                    <Route path="/internal/minutes" exact render={(props) =>
                                        <RequiresLogin>
                                            <Minutes />
                                        </RequiresLogin>
                                    } />
                                    <Route path="/internal/reports" exact render={(props) =>
                                        <RequiresLogin>
                                            <Reports />
                                        </RequiresLogin>
                                    } />
                                    <Route path="/internal/retrieval-forms" exact render={(props) =>
                                        <RequiresLogin>
                                            <RetrievalForms />
                                        </RequiresLogin>
                                    } />
                                    <Route path="/internal/deliveries" exact render={(props) =>
                                        <RequiresLogin>
                                            <Deliveries />
                                        </RequiresLogin>
                                    } />
                                    <Route path="/internal/media-status" exact render={(props) =>
                                        <RequiresLogin>
                                            <MediaStatus />
                                        </RequiresLogin>
                                    } />
                                    <Route path="/internal/damps-database" exact render={(props) =>
                                        <RequiresLogin>
                                            <DampsDatabase />
                                        </RequiresLogin>
                                    } />
                                    <Route path="/internal/KPI" exact render={(props) =>
                                        <RequiresLogin>
                                            <KPI />
                                        </RequiresLogin>
                                    } />

                                    <Route render={() =>
                                        <Redirect to="/" />
                                    } />
                                </Switch>
                            </Router>
                    }
                </div>
            </IntlProvider>
        )
    }
};

export default connect((state: any) => {
    return {
        rt_app: state.rt_app,
        languages: state.languages,
        login: state.login,
        routing: state.routing,
        gdpr: state.gdpr
    }
})(App);
